import { consumer, core, payloadToJSON } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  introText: string | null;
  requestInProgress: boolean;
  pastPurchase: {
    [id: number]: core.PastPurchase;
  };
  questions: core.TicketTypeQuestion[] | null;
  surveyExpiration: number | null;
  ticketTypeDetails: core.TicketTypeDetails | null;
}

const initialState: State = {
  introText: null,
  requestInProgress: false,
  pastPurchase: {},
  questions: null,
  surveyExpiration: null,
  ticketTypeDetails: null,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.PAST_PURCHASE_CLEAR:
      return {
        ...state,
        requestInProgress: true,
        pastPurchase: {},
      };
    case AppConstants.SURVEY_SUBMIT_DONE: {
      return {
        ...state,
        pastPurchase: {
          [payload.id]: payloadToJSON<core.PastPurchase>(payload),
        },
      };
    }
    case AppConstants.PAST_PURCHASE_TICKET_TYPE_DETAILS_CLEAR:
      return {
        ...state,
        requestInProgress: true,
        ticketTypeDetails: null,
      };
    case AppConstants.PAST_PURCHASE_FETCH_DONE: {
      const purchase = payloadToJSON<core.PastPurchase>(payload);
      return {
        ...state,
        requestInProgress: false,
        pastPurchase: {
          ...state.pastPurchase,
          [purchase.id]: purchase,
        },
      };
    }
    case AppConstants.SURVEY_FETCH_DONE: {
      const response = payloadToJSON<consumer.ConsumerQuestionnaire>(payload);
      return {
        ...state,
        requestInProgress: false,
        questions: response.question as core.TicketTypeQuestion[],
        introText: response.questionnaireIntroText,
        surveyExpiration: response.surveyExpirationNumDaysBefore,
      };
    }
    case AppConstants.TICKET_TYPE_COMMUNICATIONS_FETCH_STARTING:
    case AppConstants.PAST_PURCHASE_FETCH_STARTING:
    case AppConstants.SURVEY_FETCH_STARTING:
      return {
        ...state,
        requestInProgress: true,
      };
    case AppConstants.TICKET_TYPE_COMMUNICATIONS_FETCH_DONE:
      return {
        ...state,
        ticketTypeDetails: payload,
        requestInProgress: false,
      };
    case AppConstants.TICKET_TYPE_COMMUNICATIONS_FETCH_FAILED:
      return {
        ...state,
        requestInProgress: false,
      };
    default:
      return state;
  }
}
